export const red = '#C2514F';
export const blue = '#1D487A';
export const orange = '#F9964F';